import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CoreStateService } from '@app/core/services';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Component({
  selector: 'app-carousel-structure',
  templateUrl: './carousel-structure.component.html',
  styleUrls: ['./carousel-structure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselStructureComponent implements OnInit, OnDestroy {
  @Input() public data: any[] = [];

  public current$: Observable<any>;

  public title$: Observable<string>;

  private _slideIndex$ = new BehaviorSubject(0);

  constructor(private coreStateService: CoreStateService) {}

  public ngOnInit() {
    this.current$ = this._slideIndex$.pipe(map((index) => this.data[index]));
    this.title$ = this.coreStateService.plugin$.pipe(map((res) => `assets/svg/${res.handler.home.structure}`));
  }

  public ngOnDestroy() {
    this._slideIndex$.complete();
  }

  public onChange(index: number) {
    this._slideIndex$.next(index);
  }
}
